import styled from 'styled-components'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 40px;
`

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 90%;
  margin-bottom: 24px;
  gap: 20px;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 40px 30px 20px 30px;
`

export const TrashIconBig = styled.img`
  width: 70px;
  height: 70px;
`

export const TrashIconWhite = styled.img`
  width: 20px;
  height: 25px;
`
